<template>
    <div class="info_title">
        <!-- <span>{{userInfos}}</span> -->
        <!-- <span v-if="userInfo && userInfo.translation">{{userInfo.translation}}</span> -->
        <!-- <span :style="{color: 'green', fontWeight: 'bold'}">_\|/_</span> -->
        <div v-for="(userInfo, prop) of userInfos" :key="prop">
            <div v-if="prop != '__context' && prop != 'id' && prop != 'name' && prop != 'password' && prop != 'workspaceId' && prop != 'emailConfirmation'  && userInfo" class="info_group" :class="{'info_child': userInfosTitlesObj[prop].child}">
                <span v-if="userInfosTitlesObj[prop].child">{{" "}}</span>
                <span v-if="userInfosTitlesObj[prop].translation">{{userInfosTitlesObj[prop].translation}}: </span>
                <strong v-if="userInfo != null && (userInfo.constructor !== [].constructor && userInfo.constructor !== {}.constructor)">{{userInfo}}</strong>
                <InfoTitle 
                    v-if="userInfo != null && (userInfo.constructor === [].constructor || userInfo.constructor === {}.constructor)" 
                    :userInfos="userInfo"
                    :prop="prop">
                </InfoTitle>
            </div>
        </div>
    </div>    
</template>

<script>


export default {

    name: 'InfoTitle',

    props:{
        userInfos:{
            required: true    
        }
    },

    data: () => ({
        userInfosTitlesObj: {
            "name": {
                "translation":"Nome"
            },
            "cpf": {
                "translation": "CPF"
            },
            "email":{
                "translation": "E-mail"
            },
            "phone":{
                "translation":"Telefone"
            },
            "age":{
                "translation":"Idade"
            },
            "address":{
                "translation" : "Endereço"
            },
            "enrollmentCity":{
                "translation": "Cidade de interesse"
            },
            "cep":{
                "translation":"CEP",
                "child": true
            },
            "city":{
                "translation":"Cidade",
                "child": true
            },
            "complement":{
                "translation":"Complemento",
                "child": true
            },
            "neighborhood":{
                "translation":"Bairro",
                "child": true
            },
            "state":{
                "translation":"Estado",
                "child": true
            },
            "street":{
                "translation":"Rua",
                "child": true
            },
            "worktimeAvailability":{
                "translation":"Disponibilidade de horário"
            },
            "graduation":{
                "translation": "Graduação",
            },
            "startLesson":{
                "translation":"Horário de início",
                "child": true
            },
            "endLesson":{
                "translation":"Horário de término",
                "child": true
            },
            "conclusion":{
                "translation":"Conclusão",
                "child": true
            },
            "course":{
                "translation":"Curso",
                "child": true
            },
            "university":{
                "translation":"Universidade",
                "child": true
            },
            // "semester":{
            //     "translation":"Semestre",
            //     "child": true
            // },
            // "period":{
            //     "translation":"Período",
            //     "child": true
            // },
            "type":{
                "translation":"Tipo",
                "child": true
            },
            "language":{
                "translation": "Idioma",
            },
            "english":{
                "translation":"Inglês",
                "child": true
            },
        },
    }),
}
</script>

<style lang="scss" scoped>
.info_title{
    .info_group{
        display: flex;
        flex-direction: column;
        padding: 0 0 24px 0;
    }
    .info_child{
        padding: 0 0 0 32px;
    }
}
</style>
